<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.code }}</strong>
                </CCardHeader>
                <CCardBody>
                    <PromotionsTabLinks />
                    <PromotionsUpsertForm
                        class="mt-4 ml-2 ml-2"
                        :entity.sync="entity"
                        @success="$router.push(`/promotions`)"
                        @deleted="$router.push(`/promotions`)"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import PromotionsTabLinks from '@/components/promotions/CommonPromotionsTabLinks';
    import PromotionsUpsertForm from '@/components/promotions/PromotionsUpsertForm';

    export default {
        name: 'PromotionsEdit',

        components: {
            PromotionsTabLinks,
            PromotionsUpsertForm,
        },

        data() {
            return {
                entity: undefined,
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id } = this.$route.params;
                this.entity = (await this.axios.get(`/common-promotions/${id}`)).data;
            },
        },
    };
</script>
